import { AttendanceConstants as Constants } from '../types'
import { attendanceApi as api } from '../../api'

export const attendanceAction = {
    get,
    months,
    add,    
    update,
    remove,
    clear,
};

function get(month, filters, offset, page_size) {
    return dispatch => {
        dispatch(loading())
        return new Promise((resolve, reject) => {
            api._get(month, filters, offset, page_size)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.GET, payload } }
    function loading() { return { type: Constants.LOADING } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function months() {
    return dispatch => {
        dispatch(loading())
        return new Promise((resolve, reject) => {
            api._months()
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.MONTHS, payload } }
    function loading() { return { type: Constants.LOADING } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function add(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._add(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure('Failed'));
                        reject(error)
                    }
                )

        });
    }
    function success(payload) { return { type: Constants.GET, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function update(data, id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._update(data,id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.UPDATE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function remove(id) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._delete(id)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve()
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    function success(payload) { return { type: Constants.DELETE, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
    }
}

function clear() {
    return dispatch => {   
        return new Promise((resolve, reject) => {     
            dispatch(success());
            resolve()
        })   
    }
    function success() { return { type: Constants.CLEAR } }
}